
import Spinner from 'vux/src/components/spinner/index.vue'

export default {
props: {
more: {
type: Boolean,
default: true
},
typeIndex: {
type: Number,
default: 3
}
},
components: { Spinner },
data() {
return {
loading: false,
types: ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral']
}
},
methods: {
_loadMore() {
if (this.more) {
this.loading = true
this.$emit('loadMore', { finish: this.finish })
}
},
finish() {
this.loading = false
}
}
}



// WEBPACK FOOTER //
// ./src/common/components/load-more-btn/index.vue